// packages/eden-icons-raw/src/icons/alertWarningFilled.js
var alertWarningFilled = {
  type: "svg",
  props: {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  },
  metadata: {
    description: "Indicates a warning.",
    usage: "",
    category: "Alerts and Notifications",
    tags: ["caution", "open", "alert"]
  },
  children: [
    {
      type: "path",
      props: {
        d: "M11.104 3.717a1.035 1.035 0 011.792 0l8.964 15.526c.398.69-.1 1.552-.897 1.552H3.037a1.035 1.035 0 01-.897-1.552l8.964-15.525zm2.075 5.148h-2.357l.222 5.685h1.914l.22-5.685zm.081 8.185a1.25 1.25 0 11-2.5 0 1.25 1.25 0 012.5 0z",
        fillRule: "evenodd",
        clipRule: "evenodd"
      }
    }
  ]
};
var alertWarningFilled_default = alertWarningFilled;
export {
  alertWarningFilled_default as default
};
